import clsx from "clsx";
import { GroupBase, OptionProps, StylesConfig } from "react-select";

import { IDropdownItem } from "@ryde/shared";

export const getRideDocksEditableSelectOptionClassName = (
  state: OptionProps<IDropdownItem, false, GroupBase<IDropdownItem>>,
): string =>
  clsx("react-select__option", {
    "react-select__option--focused": state.isFocused,
  });

export const getRideDocksEditableSelectClassNames = (): {
  control: (state: { isFocused: boolean }) => string;
  menu: () => string;
  menuList: () => string;
  option: typeof getRideDocksEditableSelectOptionClassName;
} => ({
  control: state => (state.isFocused ? "react-select__control--focused" : ""),
  menu: () => "react-select__menu",
  menuList: () => "react-select__menu-list",
  option: getRideDocksEditableSelectOptionClassName,
});

export const getRideDocksEditableSelectStyles = ({
  selectedValue,
}: {
  selectedValue: number | undefined;
}): StylesConfig<IDropdownItem, false> => ({
  option: (provided, state) => ({
    ...provided,
    fontWeight: state.data.value === selectedValue ? "bold" : "normal",
  }),
});
